//  Logo is 100px x 100px by default, but can be scaled up or down.
const LOGO_BASE_WIDTH = 100;
const LOGO_BASE_HEIGHT = 100;
const LOGO_SIZE_RATIO = LOGO_BASE_WIDTH / LOGO_BASE_HEIGHT; // 1

type FOSSALogoProps = {
  width?: number;
};

/**
 * Just the FOSSA Cat Glyph icon in black and white
 *
 * @param {FOSSALogoProps} props - FOSSALogo props
 * @param {number} [props.width] - Width for the logo.
 */
const FOSSAGlyph = ({
  width,
}: FOSSALogoProps) => (
  <svg
    fill="none"
    width={width || '100%'}
    height={width ? (width / LOGO_SIZE_RATIO) : undefined}
    viewBox={`0 0 ${LOGO_BASE_WIDTH} ${LOGO_BASE_HEIGHT}`}
  >
    <path
      fill="#000"
      clipRule="evenodd"
      d="M7.635 39.476a7.168 7.168 0 0 1 3.589-9.48l47.379-21.36a7.168 7.168 0 0 1 9.48 3.588l21.361 47.379a7.168 7.168 0 0 1-3.589 9.481l-47.379 21.36a7.168 7.168 0 0 1-9.48-3.589L7.635 39.476Z" />
    <path
      fill="#fff"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.224 29.995a7.168 7.168 0 0 0-3.589 9.481l21.36 47.38a7.168 7.168 0 0 0 9.481 3.588l47.379-21.36a7.168 7.168 0 0 0 3.589-9.481l-21.36-47.379a7.168 7.168 0 0 0-9.481-3.589l-47.379 21.36ZM5.812 40.298a9.168 9.168 0 0 1 4.59-12.126l47.379-21.36a9.168 9.168 0 0 1 12.126 4.59l21.36 47.379a9.168 9.168 0 0 1-4.59 12.126l-47.379 21.36a9.168 9.168 0 0 1-12.126-4.59L5.812 40.298Z"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.194 27.647c.899-7.952 7.364-14.187 15.287-14.187 3.455 0 6.643 1.19 9.207 3.195a15.51 15.51 0 0 1 1.634 1.474c.7.702 1.743 1.144 4.004 1.374 2.274.232 5.556.234 10.563.234 7.183 0 13.748 2.48 19.138 6.556.254.192.485.4.697.609.338.334.645.691.92 1.013l.005.005c.111.13.217.253.324.373 1.276 1.45 3.603 2.957 6.554 4.192a34.825 34.825 0 0 0 9.84 2.484l.903.089v9.976l-.023.106c-1.13 5.136-3.277 8.42-5.862 11.18-1.31 1.399-2.833 2.655-4.586 3.937l-.027.02-.028.017c-1.293.821-2.83 1.067-4.282.85-4.606-.692-8.233-.882-10.572-.882-10.161 0-18.87 2.813-25.157 7.93-6.272 5.105-10.207 12.558-10.753 22.006l-.093 1.607-1.4-.796a8.135 8.135 0 0 1-3.403-3.74l-21.36-47.38a8.135 8.135 0 0 1-.68-4.194l.075-.728 9.46-1.942c-.297-1.172-.492-2.372-.492-3.47 0-.646.037-1.282.107-1.908Z"
    />
    <path
      fill="#000"
      fillRule="evenodd"
      d="M69.91 36.125c1.389-.068 2.478-1.067 2.526-2.271l-.001.002c.056-1.395-1.282-2.472-2.86-2.396-1.312.064-1.462.088-5.611 1.08-.252.06-.322.35-.117.49 4.602 3.166 4.673 3.163 6.063 3.095Z"
    />
  </svg>
);

export default FOSSAGlyph;
